import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import links from '../nav.route'
import {
    localToken
} from "@/libs/func";

//console.log(links)
import MintUI from 'mint-ui'

Vue.use(MintUI)

import Gheader from '@/components/GlobleHeader'
import Gfooter from '@/components/GlobleFooter'

import Oauth from '@/view/Oauth'
import Member from '@/view/Member/Index'

Vue.component('gheader', Gheader)
Vue.component('gfooter', Gfooter)


Vue.use(Router)
Vue.use(BootstrapVue);
//export default new Router({
const routers = new Router({
    mode: 'history',
    routes: [
        {
            path: '/', //会员首页 (默认进入)
            name: 'Member',
            component: Member,
            meta: {
                title: ''
            }
        },
        {
            path: '/Member', //会员首页
            name: 'Member',
            component: Member,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/Oauth',
            name: 'Oauth',
            component: Oauth,
            meta: {
                title: '微信授权认证'
            } //微信授权认证
        },
        {
            path: '/ErrorPage/Error',
            name: 'Error',
            component: Error,
            meta: {
                title: '报错'
            }
        },

        //以下为懒加载路由 用于提高首次进入的响应速度 如果有常用链接 可以取消该路由的懒加载
        {
            path: '/Register',
            name: 'Register',
            //component: Register,
            component: resolve => require(['@/view/Register/Register'], resolve),
            meta: {
                title: '绑定手机号'
            } //绑定手机号码
        },

        {
            path: '/Member/Integral', //积分
            name: 'Integral',
            //component: Integral,
            component: resolve => require(['@/view/Member/Integral/Integral'], resolve),
            meta: {
                title: '积分'
            }
        },
        {
            path: '/Member/RemaindSum', //余额
            name: 'RemaindSum',
            //component: RemaindSum,
            component: resolve => require(['@/view/Member/RemaindSum/RemaindSum'], resolve),
            meta: {
                title: '余额'
            }
        },
        {
            path: '/Member/Recharge', //充值
            name: 'Recharge',
            //component: Recharge,
            component: resolve => require(['@/view/Member/Recharge/Recharge'], resolve),
            meta: {
                title: '充值'
            }
        },
        {
            path: '/Member/Weixinpay', //支付回调页面
            name: 'Weixinpay',
            //component: Weixinpay,
            component: resolve => require(['@/view/Member/Recharge/Weixinpay'], resolve),
            meta: {
                title: '支付'
            }
        },
        {
            path: '/Member/Info', //个人信息
            name: 'Info',
            //component: Info,
            component: resolve => require(['@/view/Member/Info/Info'], resolve),
            meta: {
                title: '编辑资料'
            }
        },
        {
            path: '/Member/Clear', //清空缓存
            name: 'Clear',
            //component: Clear,
            component: resolve => require(['@/view/Member/Clear/Clear'], resolve),
            meta: {
                title: '清除缓存'
            }
        },

        {
            path: '/Member/Pay', //支付
            name: 'Pay',
            //component: Pay,
            component: resolve => require(['@/view/Member/Pay/Pay'], resolve),
            meta: {
                title: '付款码'
            }
        }, {
            path: '/Member/Order', //订单
            name: 'Order',
            //component: Order,
            component: resolve => require(['@/view/Member/Order/Order'], resolve),
            meta: {
                title: '订单'
            }
        }, {
            path: '/Member/OrderDetail', //订单详情
            name: 'OrderDetail',
            //component: OrderDetail,
            component: resolve => require(['@/view/Member/Order/OrderDetail'], resolve),
            meta: {
                title: '订单详情'
            }
        }, {
            path: '/Member/Coupon', //优惠券
            name: 'Coupon',
            //component: Coupon,
            component: resolve => require(['@/view/Member/Coupon/Coupon'], resolve),
            meta: {
                title: '优惠券'
            }
        }, {
            path: '/Member/BindCoupon', //绑定优惠券
            name: 'BindCoupon',
            //component: BindCoupon,
            component: resolve => require(['@/view/Member/Coupon/BindCoupon'], resolve),
            meta: {
                title: '绑定优惠券'
            }
        }, {
            path: '/Member/SaleDetail', //交易明细
            name: 'SaleDetail',
            //component: SaleDetail,
            component: resolve => require(['@/view/Member/SaleDetail/SaleDetail'], resolve),
            meta: {
                title: '交易明细'
            }
        }, {
            path: '/Member/GrowthValue', //成长值
            name: 'GrowthValue',
            //component: GrowthValue,
            component: resolve => require(['@/view/Member/GrowthValue/GrowthValue'], resolve),
            meta: {
                title: '成长值'
            }
        }, {
            path: '/Member/SignIn', //签到
            name: 'SignIn',
            //component: SignIn,
            component: resolve => require(['@/view/Member/SignIn/SignIn'], resolve),
            meta: {
                title: '签到'
            }
        }, {
            path: '/Member/Advice', //建议列表
            name: 'Advice',
            //component: Advice,
            component: resolve => require(['@/view/Member/Advice/Advice'], resolve),
            meta: {
                title: '服务建议'
            }
        }, {
            path: '/Member/Advice/AdviceList', //服务意见
            name: 'AdviceList',
            //component: AdviceList,
            component: resolve => require(['@/view/Member/Advice/AdviceList'], resolve),
            meta: {
                title: '服务意见'
            }
        }, {
            path: '/Member/Address', //地址
            name: 'Address',
            //component: Address,
            component: resolve => require(['@/view/Member/Address/Address'], resolve),
        }, {
            path: '/Member/AddAddress', //添加地址
            name: 'AddAddress',
            //component: AddAddress,
            component: resolve => require(['@/view/Member/Address/AddAddress'], resolve),
            meta: {
                title: '地址'
            }
        }, {
            path: '/Member/Set', //设置
            name: 'Set',
            //component: Set,
            component: resolve => require(['@/view/Member/Set/Set'], resolve),
            meta: {
                title: '设置'
            }
        }, {
            path: '/Member/SetPassword', //设置
            name: 'SetPassword',
            //component: SetPassword,
            component: resolve => require(['@/view/Member/Set/SetPassword'], resolve),
            meta: {
                title: '修改密码'
            }
        }, {
            path: '/Member/SetPwd', //设置
            name: 'SetPwd',
            //component: SetPwd,
            component: resolve => require(['@/view/Member/Set/SetPwd'], resolve),
            meta: {
                title: '修改密码'
            }
        }, {
            path: '/Member/ForgetPassword', //设置
            name: 'ForgetPassword',
            //component: ForgetPassword,
            component: resolve => require(['@/view/Member/Set/ForgetPassword'], resolve),
            meta: {
                title: '忘记密码'
            }
        }, {
            path: '/Member/ForgetPasswordCode', //设置忘记密码
            name: 'ForgetPasswordCode',
            //component: ForgetPasswordCode,
            component: resolve => require(['@/view/Member/Set/ForgetPasswordCode'], resolve),
            meta: {
                title: '忘记密码'
            }
        }, {
            path: '/Member/SetPhone', //设置
            name: 'SetPhone',
            //component: SetPhone,
            component: resolve => require(['@/view/Member/Set/SetPhone'], resolve),
            meta: {
                title: '更换手机'
            }
        }, {
            path: '/Member/CardManage', //设置
            name: 'CardManage',
            //component: CardManage,
            component: resolve => require(['@/view/Member/Set/CardManage'], resolve),
            meta: {
                title: '实体卡管理'
            }
        },
        {
            path: '/Member/Anniversary', //纪念日
            name: 'Anniversary',
            //component: Anniversary,
            component: resolve => require(['@/view/Member/Anniversary/Anniversary'], resolve),
            meta: {
                title: '纪念日'
            }
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
});

export default routers;


// WEBPACK FOOTER //
// ./src/router/routers.js